import { render, staticRenderFns } from "./labelPrint.vue?vue&type=template&id=36b6fbd2&scoped=true&"
import script from "./labelPrint.vue?vue&type=script&lang=js&"
export * from "./labelPrint.vue?vue&type=script&lang=js&"
import style0 from "./labelPrint.vue?vue&type=style&index=0&id=36b6fbd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b6fbd2",
  null
  
)

export default component.exports